import { saleSetActions } from './saleSetActions';

export default {
    saleSet: saleSetActions
};
